import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Container, Button, Card, Form, Row, Col } from "react-bootstrap";
import AuthHeader from "../../components/header/AuthHeader";
import { FaArrowRight } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../redux/actions/AuthUserActions";
import Swal from "sweetalert2";
import Loader from "../../components/loader/Loader";

function ForgotPasswordEmail() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const schema = Yup.object({
    email: Yup.string().email("Email invalide").required("Email requis"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      setSubmitting(true);
      dispatch(
        forgotPassword(values, (response) => handleCallback(response, values))
      );
    },
  });

  const handleCallback = ({ success, message }, values) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/forgot-password", {
        state: { email: values.email },
      });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <>
      <AuthHeader />
      <Loader isLoading={submitting} />
      <Container
        fluid
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            width: "100%",
            margin: 0,
          }}
        >
          <Col
            xs={12}
            sm={10}
            md={8}
            lg={6}
            xl={4}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Card
              style={{
                width: "100%",
                padding: "20px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                borderRadius: "18px",
                backgroundColor: "#fff",
              }}
            >
              <Card.Body>
                <h5
                  className="text-center mb-4"
                  style={{
                    color: "#FF5500",
                    fontWeight: "500",
                  }}
                >
                  RÉINITIALISER LE MOT DE PASSE
                </h5>

                <Form
                  onSubmit={formik.handleSubmit}
                  style={{ textAlign: "left" }}
                >
                  <Form.Group controlId="email" className="mb-3">
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      isInvalid={formik.touched.email && formik.errors.email}
                      style={{
                        height: "45px",
                        borderRadius: "10px",
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Button
                    type="submit"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#051259",
                      color: "#fff",
                      fontWeight: "bold",
                      height: "45px",
                      marginTop: "10px",
                    }}
                    disabled={!formik.isValid}
                  >
                    Continuer
                    <FaArrowRight style={{ marginLeft: "8px" }} />
                  </Button>
                </Form>
              </Card.Body>
              <Card.Footer
                style={{
                  backgroundColor: "#fff",
                  textAlign: "center",
                  fontSize: "14px",
                  marginTop: "10px",
                }}
              >
                <span>
                  <Link
                    onClick={() => navigate(-1)}
                    style={{
                      color: "#051259",
                      textDecoration: "underline",
                    }}
                  >
                    Retour
                  </Link>
                </span>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ForgotPasswordEmail;
